import { withT } from "neetocommons/react-utils";
import { Button, Modal, Spinner } from "neetoui";

import Search from "components/Search";

const ModalHeader = withT(
  ({ t, enableAdvancedSearch, onSearch, onGoToAdvanced, loading }) => (
    <Modal.Header className="neeto-molecules-finder-modal__header neeto-ui-border-gray-300 border-b px-0 py-0">
      <Search
        {...{ onSearch }}
        nakedInput
        autoComplete="off"
        className="neeto-molecules-finder-modal__search px-6 py-3"
        name="term"
        placeholder={t("neetoMolecules.common.actions.search")}
        suffix={
          <div className="ms-3 flex items-center">
            <div className="h-4 w-4 flex-shrink-0">
              {loading && <Spinner size="small" />}
            </div>
            {enableAdvancedSearch && (
              <Button
                className="ms-3 whitespace-nowrap"
                label={t("neetoMolecules.finderModal.advancedSearch")}
                size="small"
                style="tertiary"
                onClick={onGoToAdvanced}
              />
            )}
          </div>
        }
      />
    </Modal.Header>
  )
);

export default ModalHeader;
